import { CAPTCHA_BEFORE_BLOCKING_HISTORY_KEY } from "../../config";
import { MessageStatus } from "../../api/types";
export var saveCaptchaStageHistory = function saveCaptchaStageHistory(value, isNoNAuthCaptchaStage) {
  if (value) {
    var array = value.filter(function (_ref) {
      var messageStatus = _ref.messageStatus,
        onlyClient = _ref.onlyClient;
      return messageStatus === MessageStatus.failed || onlyClient && isNoNAuthCaptchaStage;
    });
    sessionStorage.setItem(CAPTCHA_BEFORE_BLOCKING_HISTORY_KEY, JSON.stringify(array));
  }
};